import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
const defaultItemsPerPage = 15;
export default {
  name: 'NiotaClassicDevicesListsOriginatorDevicesList',
  props: {
    list: {
      type: Array,
      required: false,
      default: new Array()
    },
    deviceTypes: {
      type: Array,
      required: false,
      default: new Array()
    },
    originator: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      devices: [],
      deviceTypeId: null,
      tableHeaders: [{
        text: this.$i18n_t('NiotaClassic.Devices.table.name'),
        value: 'name',
        align: 'start'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.eui'),
        value: 'eui',
        align: 'start'
      }, {
        text: this.$i18n_t('NiotaClassic.Devices.table.originator'),
        value: 'originator',
        align: 'start'
      }, {
        sortable: false
      }],
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      operationalStatus: [{
        value: 0,
        text: this.$i18n_t('NiotaClassic.Devices.form.unset')
      }, {
        value: 1,
        text: this.$i18n_t('NiotaClassic.Devices.form.inTransit')
      }, {
        value: 2,
        text: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation')
      }, {
        value: 3,
        text: this.$i18n_t('NiotaClassic.Devices.form.inOperation')
      }, {
        value: 4,
        text: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive')
      }, {
        value: 5,
        text: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      }]
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    n1Protocol() {
      return process.env.VUE_APP_N1_API_PROTOCOL;
    },
    n1Host() {
      return process.env.VUE_APP_N1_API_HOST;
    }
  },
  watch: {
    list() {
      this.initData();
    }
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.devices = cloneDeep(this.list);
    },
    niota1ImageUrl(imagePath) {
      if (imagePath) {
        if (/^http(?:s):\/\//i.test(imagePath)) {
          return imagePath;
        }
        return `${this.n1Protocol}://${this.n1Host}${imagePath}`;
      }
      return '';
    },
    deleteFromList(item) {
      this.$emit('update', item);
    },
    filterOpStatusItems(item, queryText) {
      return item.text.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    filterItems(item, queryText) {
      return item.title.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || item.id.toString().toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
    },
    setDeviceTypeId() {
      this.$emit('setDeviceTypeId', this.deviceTypeId);
    },
    setOperationalStatus() {
      this.$emit('setOperationalStatus', this.operationStatus);
    }
  }
};